import React from "react";
//style
import NotoB from "../../styles/font/NotoSans-Bold.woff";
import NotoR from "../../styles/font/NotoSans-Regular.woff";
import NotoL from "../../styles/font/NotoSansKR-Light.woff";
import NotoM from "../../styles/font/NotoSansKR-Medium.woff";
import styled, { createGlobalStyle } from "styled-components";
// component
import Header from "./Header";
import Title from "./Title";
import Content from "./Content";
import Footer from "./Footer";
///test
const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: noto;
    src: url("${NotoB}") format("woff");
    font-weight: 700;
    font-display: fallback;
  }

  @font-face {
    font-family: noto;
    src: url("${NotoL}") format("woff");
    font-weight: 300;
    font-display: fallback;
  }

  @font-face {
    font-family: noto;
    src: url("${NotoR}") format("woff");
    font-weight: 400;
    font-display: fallback;
  }

  @font-face {
    font-family: noto;
    src: url("${NotoM}") format("woff");
    font-weight: 500;
    font-display: fallback;
  }

  .pop-opend{overflow:hidden}

  .inr{
    position:relative;
    width: 1160px;
    min-width: 1160px;
    height:100%;
    margin:0 auto;
  }
  .gray,a.gray{
    color:#7d7d7d
    
    a{color:#7d7d7d}
  }
  .blue{
    color:#02348b
  }
  .skyblue{
    color:#118ccf
  }
  .red{
    color:#cf1111
  }
  .txt_err{
    margin-top:10px
  }
  select{
    padding: 9px;
    border: 1px solid #d7d7d7;
    border-radius: 3px;
    background: #f5f5f5;
    color: #898989;
  }
  .datepicker{
    width: 100px;
    padding: 10px;
    border: 1px solid #d7d7d7;
    border-radius: 3px;
    background: #f5f5f5;
    color: #898989;
  }
  .datepicker.v1{
    width:85px;
    padding:5px;
  }
  .btnLink{
    display:inline-block;
    min-width: 120px;    
    margin: 0 5px;
    padding: 13px 15px;
    border-radius: 3px;
    background: #02348b;
    color: #fff;
    text-align:center;
    
    &.v1{
      box-sizing:border-box;
    }
    
    &.blue {
      background: #118ccf;
    }
  }
`;

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const Body = styled.div`
  flex: 1 0 auto;
  padding-top: 50px;

  &.v1 {
    padding: 0;
  }
`;

const Layout = ({ title, children, noLnb, bodyVer, noTitle, noInr }) => {
  return (
    <>
      <GlobalStyle />
      <Wrap>
        <Header noLnb={noLnb} />
        <Body className={bodyVer ? bodyVer : null}>
          {noTitle ? null : <Title title={title} />}
          <Content children={children} noInr={noInr && noInr} />
        </Body>
        <Footer />
      </Wrap>
    </>
  );
};

export default Layout;
